<template>
  <div class="form-container">
    <CardPrime class="form-card">
      <template #content>
        <form @submit.prevent="intentarGuardar" class="form-grid">
     
          <div class="form-field">
            <InputText v-model="alumno.nombre" placeholder="Nombre" 
                       :class="{'p-invalid': mostrarErrores && errors.nombre}"
                       v-bind:[tooltipDirective]="'Ingrese el nombre del alumno'" />
            <small v-if="mostrarErrores && errors.nombre" class="p-error">{{ errors.nombre }}</small>
          </div>
          <div class="form-field">
            <InputText v-model="alumno.apellido_paterno" placeholder="Apellido Paterno" 
                       :class="{'p-invalid': mostrarErrores && errors.apellido_paterno}"
                       v-bind:[tooltipDirective]="'Ingrese el apellido paterno del alumno'" />
            <small v-if="mostrarErrores && errors.apellido_paterno" class="p-error">{{ errors.apellido_paterno }}</small>
          </div>
          <div class="form-field">
            <InputText v-model="alumno.apellido_materno" placeholder="Apellido Materno" 
                       :class="{'p-invalid': mostrarErrores && errors.apellido_materno}"
                       v-bind:[tooltipDirective]="'Ingrese el apellido materno del alumno'" />
            <small v-if="mostrarErrores && errors.apellido_materno" class="p-error">{{ errors.apellido_materno }}</small>
          </div>
          <div class="form-field">
            <InputRut 
              v-model="alumno.identificador_rut" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.identificador_rut" 
              tooltip="Ingrese el RUT del alumno" 
            />
          </div>
          <div class="form-field">
            <InputText v-model="alumno.email" placeholder="Email" type="email"
                       :class="{'p-invalid': mostrarErrores && errors.email}"
                       v-bind:[tooltipDirective]="'Ingrese el email del alumno'"  maxlength="500" />
            <small v-if="mostrarErrores && errors.email" class="p-error">{{ errors.email }}</small>
          </div>
          <div class="form-field">
            <InputText v-model="alumno.celular" placeholder="Celular"
                       :class="{'p-invalid': mostrarErrores && errors.celular}"
                       v-bind:[tooltipDirective]="'Ingrese el celular del alumno'" />
            <small v-if="mostrarErrores && errors.celular" class="p-error">{{ errors.celular }}</small>
          </div>
            <div class="form-field">
            <SexoDropdown 
              v-model="alumno.sexo" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.sexo" 
              tooltip="Seleccione el sexo del alumno" 
            />
          </div>
           <div class="form-field">
            <ColegioDropdown 
              v-model="alumno.id_colegio" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.id_colegio" 
              tooltip="Seleccione el colegio del alumno" 
            />
          </div>
          <div class="form-field">
            <SingleCursoCombo
              :mostrarErrores="true" 
              :tooltip="'Selecciona un Curso'" 
              :error="errors.cursos" 
              :modelValue="alumno.cursos" 
              @update:modelValxue="actualizarCursos" 
            />
            <small v-if="mostrarErrores && errors.cursos" class="p-error">{{ errors.cursos }}</small>
          </div>

          <!--div class="form-field">
            <AsignaturaDropdown 
              v-model="alumno.asignaturas" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.asignaturas" 
              tooltip="Seleccione las asignaturas del alumno" 
            />
            <small v-if="mostrarErrores && errors.asignaturas" class="p-error">{{ errors.asignaturas }}</small>
          </div-->

          <div class="form-field">
            <CursoCasaDropdown 
              v-model="alumno.curso_casa" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.curso_casa" 
              tooltip="Seleccione el curso casa del alumno" 
            />
            <small v-if="mostrarErrores && errors.curso_casa" class="p-error">{{ errors.curso_casa }}</small>
          </div>
          <div class="form-field">
            <InputText v-model="alumno.direccion_calle" placeholder="Calle Dirección"
                       :class="{'p-invalid': mostrarErrores && errors.direccion_calle}"
                       v-bind:[tooltipDirective]="'Ingrese la calle de la dirección del alumno'"  maxlength="500"  />
            <small v-if="mostrarErrores && errors.direccion_calle" class="p-error">{{ errors.direccion_calle }}</small>
          </div>
          <div class="form-field">
            <InputNumber v-model="alumno.direccion_numero" placeholder="Número Dirección"
                         :class="{'p-invalid': mostrarErrores && errors.direccion_numero}"
                         v-bind:[tooltipDirective]="'Ingrese el número de la dirección del alumno'" />
            <small v-if="mostrarErrores && errors.direccion_numero" class="p-error">{{ errors.direccion_numero }}</small>
          </div>
          <div class="form-field">
            <RegionDropdown 
              v-model="alumno.id_region" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.id_region" 
              tooltip="Seleccione la región del alumno" 
            />
          </div>
          <div class="form-field">
            <ComunaDropdown 
              v-model="alumno.id_comuna" 
              :mostrarErrores="mostrarErrores" 
              :error="errors.id_comuna" 
              tooltip="Seleccione la comuna del alumno" 
            />
          </div>

               <div class="form-field">
            <InputText v-model="alumno.nombre_usuario" placeholder="Nombre de Usuario" 
                       :class="{'p-invalid': mostrarErrores && errors.nombre_usuario}"
                       v-bind:[tooltipDirective]="'Ingrese el nombre de usuario'" />
            <small v-if="mostrarErrores && errors.nombre_usuario" class="p-error">{{ errors.nombre_usuario }}</small>
          </div>

          <div class="form-field">
            <PasswordPrime v-model="alumno.pass_" placeholder="Contraseña" :feedback="false"
                      :class="{'p-invalid': mostrarErrores && errors.pass_}" toggleMask
                      v-bind:[tooltipDirective]="'Ingrese la contraseña del alumno'" />
            <small v-if="mostrarErrores && errors.pass_" class="p-error">{{ errors.pass_ }}</small>
          </div>
          <div class="form-field"> <!-- Nuevo campo para la frase secreta -->
            <InputText v-model="alumno.frase_secreta" placeholder="Frase Secreta" 
                       :class="{'p-invalid': mostrarErrores && errors.frase_secreta}" 
                       v-bind:[tooltipDirective]="'Ingrese la frase secreta'" />
            <small v-if="mostrarErrores && errors.frase_secreta" class="p-error">{{ errors.frase_secreta }}</small>
          </div>

          <div class="form-actions">
            <ButtonPrime type="button" label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cancelar" />
            <ButtonPrime type="submit" label="Guardar" icon="pi pi-check" class="p-button-primary" :disabled="hayErrorCurso" />
          </div>
        </form>
      </template>
    </CardPrime>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'; 

import alumnoService from '@/services/AlumnoService'; // Asegúrate de que el servicio sea correcto
import SexoDropdown from '@/components/selectores/SexoDropdown.vue';

import ColegioDropdown from '@/components/selectores/ColegioDropdown.vue';
import RegionDropdown from '@/components/selectores/RegionDropdown.vue';
import ComunaDropdown from '@/components/selectores/ComunaDropdown.vue';
import CursoCasaDropdown from '@/components/selectores/CursoCasaDropDown.vue';

import SingleCursoCombo from '@/components/selectores/SingleCursoCombo.vue';

//import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue';
import InputRut from '@/components/InputRut.vue'; // Importa el nuevo componente InputRut

export default {
  components: {
    SingleCursoCombo,
    SexoDropdown,
    ColegioDropdown,
    RegionDropdown,
    ComunaDropdown,
    CursoCasaDropdown,
    //AsignaturaDropdown,
    InputRut, // Registra el nuevo componente InputRut
  },
  setup() {
    const route = useRoute(); 
    const router = useRouter();
    const mostrarErrores = ref(false);
    const tooltipDirective = ref('tooltip');
    const mensajeError = ref('');
    const hayErrorCurso = ref(false);

    const alumno = reactive({
      nombre_usuario: '',
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      identificador_rut: '',
      sexo: '',
      email: '',
      celular: '',
      cursos: [],
      asignaturas: [],
      curso_casa: '',
      id_colegio: null,
      direccion_calle: '',
      direccion_numero: null,
      id_region: 6, // ID de la región por defecto
      id_comuna: 45, // ID de la comuna por defecto
      pass_: '',
      frase_secreta: '' // Agregada la propiedad para la frase secreta
    });

    const errors = reactive({});

    const cursosOriginales = computed(() => 
      route.query.cursos ? route.query.cursos.split(',').map(Number) : []
    );

    onMounted(() => {
      const cursosParam = route.query.cursos;
      if (cursosParam) {
        alumno.cursos = cursosParam.split(',').map(Number);
        console.log(alumno.cursos)
      }
    });

    const actualizarCursos = (nuevosCursos) => {
      if (nuevosCursos.length > 0) {
        const cursoSeleccionado = nuevosCursos[nuevosCursos.length - 1];
        
        if (cursosOriginales.value.includes(cursoSeleccionado)) {
          // Mover el curso seleccionado al principio y eliminar duplicados
          alumno.cursos = [cursoSeleccionado, ...cursosOriginales.value.filter(c => c !== cursoSeleccionado)];
          hayErrorCurso.value = false;
          mensajeError.value = '';
        } else {
          const cursosDisponibles = cursosOriginales.value.join(', ');
          mensajeError.value = `El alumno seleccionado para adjuntar detalle contrato no tiene el curso seleccionado. Cursos disponibles: ${cursosDisponibles}`;
          alert(mensajeError.value);
          hayErrorCurso.value = true;
          // Revertir la selección
          alumno.cursos = [...cursosOriginales.value];
        }
      } else {
        alumno.cursos = [];
        hayErrorCurso.value = false;
        mensajeError.value = '';
      }
    };

    const validarFormulario = () => {
      console.log(alumno);
      errors.nombre_usuario = !alumno.nombre_usuario ? 'El nombre de usuario es requerido' : '';
      errors.nombre = !alumno.nombre ? 'El nombre es requerido' : '';
      errors.apellido_paterno = !alumno.apellido_paterno ? 'El apellido paterno es requerido' : '';
      errors.apellido_materno = !alumno.apellido_materno ? 'El apellido materno es requerido' : '';
      errors.identificador_rut = !alumno.identificador_rut ? 'El RUT es requerido' : 
                                 !validarRut(alumno.identificador_rut) ? 'RUT inválido' : '';
      errors.sexo = !alumno.sexo ? 'El sexo es requerido' : '';
      errors.email = !alumno.email ? 'El email es requerido' : 
                     !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(alumno.email) ? 'Email inválido' : '';
      errors.celular = !alumno.celular ? 'El celular es requerido' : 
                      !/^[0-9]+$/.test(alumno.celular) ? 'Debe contener solo números' : '';
      errors.cursos = !alumno.cursos || alumno.cursos.length === 0 ? 'Debe seleccionar al menos un curso' : '';
      //errors.asignaturas = !alumno.asignaturas || alumno.asignaturas.length === 0 ? 'Debe seleccionar al menos una asignatura' : '';
      errors.curso_casa = !alumno.curso_casa ? 'El curso casa es requerido' : '';
      errors.id_colegio = !alumno.id_colegio ? 'El colegio es requerido' : '';
      errors.direccion_calle = !alumno.direccion_calle ? 'La calle es requerida' : '';
      errors.direccion_numero = !alumno.direccion_numero ? 'El número es requerido' : '';
      errors.id_region = !alumno.id_region ? 'La región es requerida' : '';
      errors.id_comuna = !alumno.id_comuna ? 'La comuna es requerida' : '';
      errors.pass_ = !alumno.pass_ ? 'La contraseña es requerida' : 
                     alumno.pass_.length < 8 ? 'Mínimo 8 caracteres' : '';
      errors.frase_secreta = !alumno.frase_secreta ? 'La frase secreta es requerida' : ''; // Validación de la frase secreta
    };

    const intentarGuardar = () => {
      mostrarErrores.value = true;
      validarFormulario();
      if (Object.values(errors).every(error => error === '') && !hayErrorCurso.value) {
        guardarAlumno();
      }
    };

    const guardarAlumno = async () => {
      try {
        const encoder = new TextEncoder();
        const byteArray = encoder.encode(alumno.pass_); // Codifica la contraseña
        const base64Password = btoa(String.fromCharCode(...byteArray)); // Convierte a base64

        // Prepara el objeto para enviar
        alumno.pass_ = base64Password;
        alumno.PassphraseEnteredByUser = alumno.frase_secreta;
        const alumnoData = {
          ...alumno,
          id_usuario: parseInt(route.params.id_usuario, 10) // Convierte a entero
        };

        await alumnoService.crearAlumno(alumnoData); // Envía el objeto modificado
        router.push('/admin-alumno'); // Redirige después de guardar
      } catch (error) {
        console.error('Error al guardar alumno:', error);
      }
    };

    const cancelar = () => {
      router.push('/admin-alumno');
    };

    function validarRut(rut) {
      // Implementa aquí la lógica de validación de RUT
      // Ejemplo simple de validación
      const rutSinFormato = rut.replace(/\D/g, '');
      if (rutSinFormato.length < 8 || rutSinFormato.length > 9) return false;
      // Aquí puedes agregar más lógica de validación si es necesario
      return true; // Placeholder
    }

    onMounted(() => {
      tooltipDirective.value = 'tooltip.focus.top';
    });

    return {
      alumno,
      errors,
      mostrarErrores,
      intentarGuardar,
      cancelar,
      tooltipDirective,
      mensajeError,
      actualizarCursos,
      hayErrorCurso
    };
  }
}
</script>

<style scoped>
:deep(.p-tooltip) {
  max-width: 250px;
}
</style>
 


